// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__ezbQ5","closeButton":"styles_closeButton__tNjtJ","sideMenuListWrapper":"styles_sideMenuListWrapper__RWCQv"};